import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputDialog } from '../../models/dialog.model';

@Component({
    standalone: false,
    selector: 'octo-form-dialog',
    templateUrl: './form-dialog.component.html',
    styleUrls: ['./form-dialog.component.scss'],
})
export class FormDialogComponent {
    selectedAddress: number;

    constructor(
        private modalRef: MatDialogRef<FormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: InputDialog
    ) {
        this.selectedAddress = this.data.fields.length > 1 ? 1 : 0;
    }

    close(): void {
        this.modalRef.close({
            selectedAddress: null,
        });
    }

    continueWithoutValidation(): void {
        const address = this.data.fields[this.selectedAddress]?.value;
        this.modalRef.close({
            selectedAddress: address,
            proceedWithoutValidation: true,
        });
    }

    submitAddress(): void {
        const address = this.data.fields[this.selectedAddress]?.value;
        this.modalRef.close({
            selectedAddress: address,
        });
    }
}
